import { type FC } from "react";
import GxButton from "@/app/components/common/actions/buttons/GxButton";

interface StepFooterProps {
  isLast: boolean;
  isFirst: boolean;
  onSkip: () => void;
  onBack: () => void;
  onNext: () => void;
}

const StepFooter: FC<StepFooterProps> = ({
  isLast,
  isFirst,
  onSkip,
  onBack,
  onNext,
}) => (
  <div className="flex items-center gap-4 mt-8 pt-6 border-t border-gray-100">
    <GxButton
      variant="outlined"
      bgColor="#666666"
      width="custom"
      customWidth="6rem"
      height="medium"
      onClick={onSkip}
    >
      Skip
    </GxButton>
    <div className="ml-auto flex items-center gap-4">
      {/* <GxButton
        variant="outlined"
        bgColor="#666666"
        width="custom"
        customWidth="7rem"
        height="medium"
        onClick={onSkipThis}
      >
        Skip this
      </GxButton> */}
      {!isFirst && (
        <GxButton
          variant="outlined"
          bgColor="#666666"
          width="custom"
          customWidth="6rem"
          height="medium"
          onClick={onBack}
        >
          Back
        </GxButton>
      )}
      <GxButton
        variant="filled"
        bgColor="#000000"
        textColor="#ffffff"
        width="custom"
        customWidth="8rem"
        height="medium"
        onClick={onNext}
      >
        {isLast ? "Complete" : "Next"}
      </GxButton>
    </div>
  </div>
);

export default StepFooter;
